module.exports = __webpack_public_path__ + "img/cash-cent-child-1246954.23eab943.png";